import { useIntl } from 'react-intl';
import React from 'react';
import { useGlobalNavContext } from '../../../../../state';
import { getDropdownItemListKey } from '../../../../../utils/dropdownItemKey';
import { DropdownProps } from '../../../../../types';
import { NavLink } from '../../Links';
import { NestedDropdownItem } from '../NestedDropdownItem';
import styles from './Dropdown.module.scss';

export const Dropdown = ({ dropdownItems }: DropdownProps) => {
    const { env } = useGlobalNavContext();
    const { formatMessage } = useIntl();
    return (
        <ul
            className={styles.dropdown}
            aria-label={formatMessage({ id: 'submenu', defaultMessage: 'submenu' })}
            data-testid="global-nav-dropdown"
            tabIndex={-1}
        >
            {dropdownItems?.map(
                (
                    {
                        dropdownItems,
                        heapIdentifier,
                        translatedText,
                        path = '',
                        iconType,
                        textColor,
                        className = '',
                        iconPosition,
                        mobileDividerTop,
                    },
                    index,
                ) =>
                    dropdownItems ? (
                        <NestedDropdownItem
                            heapIdentifier={heapIdentifier}
                            translatedText={translatedText}
                            path={path}
                            iconType={iconType}
                            dropdownItems={dropdownItems}
                            mobileDividerTop={mobileDividerTop}
                            key={getDropdownItemListKey(index, heapIdentifier, path)}
                        />
                    ) : (
                        <li
                            key={getDropdownItemListKey(index, heapIdentifier, path)}
                            data-testid="link-container__level1"
                            className={styles.navLinkContainer}
                            {...(mobileDividerTop
                                ? { 'data-globalnav-mobile-divider-top': '' }
                                : {})}
                        >
                            <NavLink
                                path={new URL(path, env?.serverUrl ?? '').href}
                                heapIdentifier={heapIdentifier}
                                translatedText={translatedText}
                                textColor={textColor}
                                iconType={iconType}
                                iconPosition={iconPosition}
                                className={className || styles.navLinkDropdown}
                            />
                        </li>
                    ),
            )}
        </ul>
    );
};
